import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Projects API
export const getProjects = async (category = null) => {
  try {
    const url = category ? `${API}/projects?category=${category}` : `${API}/projects`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

export const getProject = async (id) => {
  try {
    const response = await axios.get(`${API}/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching project ${id}:`, error);
    throw error;
  }
};

// Contact API
export const submitContact = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

// About API
export const getAbout = async () => {
  try {
    const response = await axios.get(`${API}/about`);
    return response.data;
  } catch (error) {
    console.error('Error fetching about info:', error);
    throw error;
  }
};
